/* eslint-disable */
export default {
  methods: {
    initOneSignal: function (selectedLocation) {
      // if cordova is present then the device being used should be a mobile
      if (window.cordova) {
        // NOTE: Update the setAppId value below with your OneSignal AppId.
        window.plugins.OneSignal.initialize(
          "726ae9fd-cdf4-49fe-8357-9ba42ef4c08e"
        );

        // function to handle the opening of a notification
        window.plugins.OneSignal.Notifications.addEventListener(
          "click",
          (event) => {
            const redirectUrl = event.notification.additionalData.redirectURL;

            if (redirectUrl) {
              window.location.replace(redirectUrl);
            }
          }
        );

        // method to prompt the user for push notifications
        window.plugins.OneSignal.Notifications.requestPermission(false).then(
          (accepted) => {
            console.log("User accepted notifications: " + accepted);
          }
        );

        // method for sending a custom tag, uncomment to use
        if (selectedLocation && selectedLocation.length > 0) {
          window.plugins.OneSignal.User.addTag("location", selectedLocation);
        }
      }
    },
    updateOneSignalLocation: function (selectedLocation) {
      if (window.cordova) {
        window.plugins.OneSignal.initialize(
          "726ae9fd-cdf4-49fe-8357-9ba42ef4c08e"
        );

        if (selectedLocation && selectedLocation.length > 0) {
          window.plugins.OneSignal.User.addTag("location", selectedLocation);
        }
      }
    },
  },
};
/* eslint-enable */